export const DOMAIN = 'eventsports-api.clarovideo.net'


// WEBPACK FOOTER //
// ./src/requests/tasks/sports/const.js